export function useSite() {
  const site = useContentStore().site
  if (!site) throw new Error('Site not loaded')
  return site
}
